import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["level"];

/* eslint-disable import/order */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types'; // No need for internal system, system enherits from Text

import Text, { SYSTEM_PROPS } from '../Text';

const Caption = /*#__PURE__*/function () {
  const Caption = /*#__PURE__*/forwardRef(function (_ref, ref) {
    var level = _ref.level,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);

    return /*#__PURE__*/React.createElement(Text, _extends({
      ref: ref
    }, rest, {
      size: "Caption" + level
    }));
  });
  Caption.displayName = 'Caption';
  Caption.identifier = Caption.displayName;
  Caption.clonableProps = SYSTEM_PROPS;
  Caption.defaultProps = {
    as: 'p',
    decoration: 'none',
    fontFamily: 'system',
    fontWeight: 'regular',
    level: 1,
    textAlign: 'inherit'
  };
  Caption.propTypes = {
    /** Change the rendered HTML tag e.g. span, p, h1 */
    as: PropTypes.oneOfType([PropTypes.func, PropTypes.string, PropTypes.node, PropTypes.object]),

    /** Content for component *required */
    children: PropTypes.node.isRequired,

    /** Extend classNames. */
    className: PropTypes.string,

    /** Changes the Caption's color, choose one of the tokens. */
    color: PropTypes.string,

    /** Sets the css text-decoration property. */
    decoration: PropTypes.oneOf(['inherit', 'none', 'underline', 'line-through']),

    /** Sets the css font-family property. */
    fontFamily: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'system']),

    /** Sets the css font-style property. */
    fontStyle: PropTypes.oneOf(['inherit', 'normal', 'italic', 'oblique']),

    /** Sets the css font-weight property. */
    fontWeight: PropTypes.oneOf(['inherit', 'regular', 'medium', 'bold']),

    /** Maps token scale to font-size and line-height */
    level: PropTypes.oneOf([1, 2]),

    /** Extend style. */
    style: PropTypes.shape({}),

    /** Sets the css text-align property. */
    textAlign: PropTypes.oneOf(['inherit', 'left', 'right', 'center', 'justify']),

    /** Sets the css text-transform property. */
    textTransform: PropTypes.oneOf(['inherit', 'none', 'capitalize', 'uppercase', 'lowercase'])
  };
  return Caption;
}();

export default Caption;